// extracted by mini-css-extract-plugin
export default {"container":"qxn8tzCW"};